import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"top":"","color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c(VBtn,{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.show = false}}},[_c(VIcon,[_vm._v("fa-times-circle")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }